import { useMutation } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";

export default function useAsset() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();

    function useDownload() {
        return useMutation({
            mutationFn: async (params: any) => {
                const response = await axiosPrivate.get(`/v1/asset/download`, {
                    params,
                    responseType: "blob", // ⬅️ This is key for binary file downloads
                });

                // Try to extract filename from header
                const filename = response.headers["file-name"] || "download-file";

                // Create temporary download link
                const blob = new Blob([response.data]);
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement("a");

                link.href = blobUrl;
                link.download = filename;
                document.body.appendChild(link);
                link.click();

                // Cleanup
                window.URL.revokeObjectURL(blobUrl);
                document.body.removeChild(link);

                return true; // or any other value to return
            },
        });
    }

    return { useDownload };
}
